
import Vue from 'vue';
import { Icon, DropDownMenuOption } from '@descomplica/vue-components';
import { finalAssessmentsLink } from '@/settings/constants';

export default Vue.extend({
  components: {
    DropDownMenuOption,
    Icon,
  },
  computed: {
    isUndergraduateCourse(): boolean {
      return this.$store.getters.isUndergraduateCourse;
    },
  },
  methods: {
    goToLink() {
      window.open(finalAssessmentsLink, '_blank');
    },
  },
});
